import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import { CategoryInfoForUserAd } from '../../types';
import classes from './index.module.scss';
type UserAdsDetailProps = {
  totalAds: number;
  categories: Array<CategoryInfoForUserAd>;
};
const UserAdsDetail = t0 => {
  const $ = _c(13);
  const {
    totalAds,
    categories
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classnames("headline-6", "book", [classes.title]);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== totalAds) {
    t2 = <h6 className={t1}>Annunci totali: <b>{totalAds}</b></h6>;
    $[1] = totalAds;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== categories || $[4] !== totalAds) {
    let t4;
    if ($[6] !== totalAds) {
      t4 = c => <li className={classes["user-ads-detail__category"]} key={c.category.id}><p className={classnames("subheading", "small", classes["category-name"])}>{c.category.label}</p><div className={classes["category-row"]}><img alt="category" width={24} height={24} src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/static/icons/categories/${c.category.id}.svg`} /><div aria-hidden="true" className={classes["category-bar"]} style={{
            width: `${Math.round(c.approvedAds / totalAds * 100)}%`
          }} /><p className="caption small">{c.approvedAds}</p></div></li>;
      $[6] = totalAds;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t3 = categories.map(t4);
    $[3] = categories;
    $[4] = totalAds;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <ol className={classes["category-list"]}>{t3}</ol>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <section>{t2}{t4}</section>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default UserAdsDetail;